import R from 'ramda';
import React from 'react';
import classNames from 'classnames';

import { Tooltip } from '../../common/components/core';

class Queue {
  constructor(callback) {
    this.callback = callback;
    this.currentIndex = 0;
    this.currentDone = -1;
  }

  push = (value, fn) => {
    if (!value) {
      this.callback([]);
      this.currentDone = ++this.currentIndex;
      return;
    }

    const index = this.currentIndex++;
    fn(value, res => {
      if (index > this.currentDone) {
        this.currentDone = index;
        this.callback(res);
      }
    });
  };
}

class Autocomplete extends React.Component {
  static defaultProps = {
    onChange: () => {},
    load: () => {},
    search: () => {}
  };

  setOptions = result => {
    this.setState({ options: result });
  };

  setResult = res => {
    const { mounted } = this.state;
    if (mounted) {
      this.setState({
        savedText: res.text,
        savedImage: res.image
      });
    }
  };

  state = {
    options: [],
    editing: this.props.editing,
    searchTerm: '',
    savedKey: this.props.value || '',
    savedText: '',
    savedImage: '',
    queue: new Queue(this.setOptions),
    mounted: false
  };

  componentDidMount() {
    this.setState({ mounted: true });
    this.props.load(this.props.value, this.setResult);
  }

  componentWillUnmount() {
    this.setState({ mounted: false });
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.editing !== prevProps.editing &&
      this.props.editing !== this.state.editing
    ) {
      this.setState({ editing: this.props.editing });
    }

    if (this.props.value && this.props.value !== prevProps.value) {
      this.props.load(this.setResult);
    }
  }

  onChange = event => {
    this.setState({
      searchTerm: event.target.value
    });
    this.state.queue.push(event.target.value, this.props.search);
    if (!event.target.value) {
      this.props.onChange();
    }
  };

  select = (i, e) => {
    if (this.props.marketing) {
      e.preventDefault();
    }

    this.props.onChange(this.state.options[i]);
    this.setState({
      editing: false,
      savedKey: this.state.options[i].key,
      savedText: this.state.options[i].text,
      savedImage: this.state.options[i].image
    });
  };

  change = () => {
    if (this.props.disabled) {
      return;
    }

    this.setState({
      editing: true,
      searchTerm: this.state.savedText
    });
    this.state.queue.push(this.state.savedText, this.props.search);
  };

  render() {
    var containerClass =
        'autocomplete-container form-group' +
        (this.props.warning ? ' has-warning' : ''),
      container;
    if (this.state.editing) {
      var options = [];
      for (var i = 0; i < this.state.options.length; i++) {
        options.push(
          <li
            key={this.state.options[i].key}
            onClick={R.partial(this.select, [i])}
          >
            <img src={this.state.options[i].image} />{' '}
            <h4>{this.state.options[i].text}</h4>
          </li>
        );
      }
      var optionWrapper = options.length ? (
        <ul className="autocomplete-options">{options}</ul>
      ) : null;

      container = (
        <div className={containerClass}>
          <div className="autocomplete-input">
            {this.props.label == 'Android App' ? (
              <div
                style={{
                  position: 'absolute',
                  lineHeight: '30px',
                  right: '5px'
                }}
              >
                <span>Didn't find your app?</span>
                <Tooltip title="If you didn't find your app, click Custom URL to APK file and paste the Google Play URL of your app, example: https://play.google.com/store/apps/ details?id=com.example" />
              </div>
            ) : (
              ''
            )}
            <input
              id={this.props.id}
              type="text"
              className="form-control"
              onChange={this.onChange}
              value={this.state.searchTerm}
              placeholder={this.props.placeholder}
            />
          </div>
          {optionWrapper}
        </div>
      );
    } else {
      container = (
        <div className={containerClass}>
          <div
            className={classNames('autocomplete-badge h_cur-p', {
              'autocomplete-badge--disabled': this.props.disabled
            })}
            onClick={this.change}
          >
            <img src={this.state.savedImage} /> <h4>{this.state.savedText}</h4>
          </div>
        </div>
      );
    }

    if (this.props.horizontal) {
      return <div>{container}</div>;
    } else {
      return <div>{container}</div>;
    }
  }
}

export default Autocomplete;
